import type { SmartLinkChoreographer } from '@atlaskit/link-provider/types';
import {
	createChoreographedContent,
	type ChoreographerHook,
} from '@atlaskit/link-provider/create-choreographed-content';
import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

const useProductChoreographer: ChoreographerHook = (messageId, callbacks, messageTtl) => {
	const { useChoreographer } = useChoreographerAssets();
	return useChoreographer(messageId, callbacks, messageTtl);
};

export const SmartCardChoreographer: SmartLinkChoreographer =
	createChoreographedContent(useProductChoreographer);
